/** See `src/i18n/locales/en/subscription.ts` for context on the `// legal` keys. */
export const subscription = {
  title: 'Abonnement',
  lead: 'Verwalte dein eigenes Abonnement — Plan, Zahlung und Kündigung.',
  dialogCancel: 'Abbrechen',
  status: {
    title: 'Status',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    tier: 'Plan',
    expires: 'Läuft ab am',
    autoRenews: 'Wird automatisch verlängert',
    doesNotRenew: 'Wird nicht verlängert',
    nextCharge: 'Nächste Abbuchung',
    blocked: 'Du kannst derzeit kein Web-Abonnement starten.',
  },
  plans: {
    title: 'Pläne',
    monthly: 'Monatlich',
    yearly: 'Jährlich',
    perMonth: '{{price}} / Monat',
    perYear: '{{price}} / Jahr',
    subscribe: 'Abonnieren',
    current: 'Aktueller Plan',
    switchToYearly: 'Zu jährlich wechseln',
    switchToMonthly: 'Zu monatlich wechseln',
    // legal
    switchWarning:
      'Der Wechsel kündigt dein aktuelles Abonnement und startet das neue sofort mit demselben Zahlungsmandat. Die Überschneidung der beiden Zeiträume wird nicht gutgeschrieben — dafür kann eine doppelte Abbuchung erfolgen.',
    switchConfirm: 'Ja, Plan wechseln',
    blocked:
      'Du hast bereits ein aktives Abonnement, daher kann jetzt kein anderer Plan gestartet werden.',
  },
  manage: {
    title: 'Verwalten',
    cancel: 'Abonnement kündigen',
    cancelConfirm: 'Ja, kündigen',
    cancelled: 'Gekündigt — Zugriff bleibt bis {{date}} bestehen.',
    // legal
    proRataNote:
      'Beim Jahresplan werden bei Kündigung nach der ersten Zahlungsperiode die ungenutzten vollen Monate zurückerstattet und der Zugriff endet sofort, statt am Ende des Zeitraums.',
    withdraw: 'Widerrufen (innerhalb von 14 Tagen)',
    withdrawHint: 'Verfügbar bis 14 Tage nach deiner ersten Zahlung, einmalig, pro Abonnement.',
  },
  history: {
    title: 'Verlauf',
    empty: 'Noch keine Käufe.',
    date: 'Datum',
    period: 'Zeitraum',
    channel: 'Kanal',
    state: 'Status',
    state_granted: 'Gewährt',
    state_refunded: 'Erstattet',
    state_revoked: 'Widerrufen',
    state_charged_back: 'Rückbuchung',
    state_rejected: 'Abgelehnt',
    invoice: 'Rechnung',
    withdrawLink: 'Widerrufen',
    manageLink: 'Im Shop verwalten',
  },
  checkout: {
    title: 'Kasse',
    lead: 'Prüfe deinen Plan, bevor du zu Mollie weitergehst.',
    plan: 'Plan',
    price: 'Preis',
    // legal — §7.5-Zustimmung zur sofortigen Leistungserbringung, inhaltlich
    // aus dem niederländischen Original in PLAN-FASE1.md übernommen.
    consentLabel:
      'Ich möchte, dass der Dienst sofort beginnt, und verstehe, dass ich bei Widerruf anteilig für den bereits genutzten Teil zahle.',
    start: 'Weiter zu Mollie',
    errorAlreadySubscribed: 'Du hast bereits ein aktives Abonnement.',
    errorProductUnavailable: 'Dieser Plan ist derzeit nicht verfügbar.',
  },
  return: {
    title: 'Zahlungsstatus',
    waiting: 'Wir warten noch auf die Bestätigung deiner Zahlung.',
    success: 'Zahlung erhalten — dein Abonnement ist aktiv.',
    backToSubscription: 'Zurück zu deinem Abonnement',
  },
  withdraw: {
    title: 'Abonnement widerrufen',
    // legal — Widerrufsrecht (art. 6:230oa BW, NL).
    lead: 'Der Widerruf innerhalb deiner 14-tägigen Widerrufsfrist beendet deinen Zugriff sofort — anders als die Kündigung, die bis zum Ende des bereits bezahlten Zeitraums läuft.',
    refundTypeFull: 'Du erhältst eine vollständige Rückerstattung.',
    refundTypeProRata:
      'Du erhältst eine anteilige Rückerstattung für den noch nicht genutzten Teil.',
    refundAmount: 'Erstattungsbetrag',
    deadline: 'Frist',
    confirm: 'Widerrufen und Zugriff jetzt beenden',
    confirmed: 'Widerrufen — {{amount}} wird erstattet.',
    errorWindowExpired: 'Die 14-tägige Widerrufsfrist ist abgelaufen.',
    errorAlreadyWithdrawn: 'Du hast dieses Abonnement bereits widerrufen.',
  },
} as const;
